import mixins from 'vue-typed-mixins';

import { Eフェーズ種別 } from '@/openapi/enum';

import C計画書データ表示設定CheckBox from '@/components/計画書データ表示設定CheckBox/計画書データ表示設定CheckBox.vue';

import PlbscfKeystrokeResetMixin from '@/entries/user/mixins/PlbscfKeystrokeResetMixin';
import 計画Plbscf業績予測Mixin from '@/entries/user/mixins/計画Plbscf業績予測Mixin';

import 計画PlbscfService from '@/classes/service/計画/計画PlbscfService';

export default mixins(計画Plbscf業績予測Mixin, PlbscfKeystrokeResetMixin).extend({
  name: 'M計画PlbscfMixin',

  components: {
    C計画書データ表示設定CheckBox,
  },

  data(): {
    service: 計画PlbscfService;
  } {
    return {
      service: new 計画PlbscfService(Eフェーズ種別.計画フェーズ),
    };
  },

  async created(): Promise<void> {
    await this.loadAndResetKeystroke();
  },

  methods: {
    async load(): Promise<void> {
      await this.loadByService(this.service);
    },
    onChange表示設定(): void {
      this.計画Plbscf = this.service.create計画Plbscf(true);
      this.initializeFlag();
      this.addKeystrokeResetCount();
    },
    async loadAndResetKeystroke(): Promise<void> {
      await this.load();
      this.addKeystrokeResetCount();
    },
  },
});
